import type { Maybe, QuoraSettings } from '@types/gatsby-types';
import { graphql, useStaticQuery } from 'gatsby';

const query = graphql`
    query QuoraPixelIdQuery {
        settings {
            quora {
                enabled
                pixelId
            }
        }
    }
`;

type QuoraPixelIdQuery = {
    settings: Maybe<{
        quora: Maybe<Pick<QuoraSettings, 'pixelId' | 'enabled'>>;
    }>;
};

type UseQuoraPixelId = {
    enabled: boolean;
    pixelId: string | null;
};

export default function useQuoraPixelId(): UseQuoraPixelId {
    const { settings } = useStaticQuery<QuoraPixelIdQuery>(query);

    return {
        enabled: !!settings?.quora?.enabled,
        pixelId: settings?.quora?.pixelId ?? null,
    };
}
